import DefaultLayout from 'layouts/DefaultLayout/DefaultLayout';
import React, { useEffect, useState } from 'react';
import { $api } from 'services/service';
import { useDispatch } from 'react-redux';
import { setAlert, setLoading } from 'redux/authSlice';
import ErrorDialog from 'components/Elements/ErrorDialog/ErrorDialog';
import Button from '../../../components/Elements/Button/Button';
import moment from 'moment';
import Pagination from '../../../components/Elements/Pagination/Pagination';
import Moment from 'react-moment';
import ConfirmDialog from '../../../components/Elements/ConfirmDialog/ConfirmDialog';
import { Link, useLocation } from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function SubjectTeachingSearch() {
    const dispatch = useDispatch();
    const [faculty, setFaculty] = useState('');
    const [faculties, setFaculties] = useState([]);
    const query = useQuery();
    // let faId: any = localStorage.getItem('faculty') ? localStorage.getItem('faculty') : query.get('f');
    const [faId, setFaId] = useState(query.get('f') || localStorage.getItem('faculty') || '');
    const [errDialog, setErrDialog] = useState({ isOpen: false, subTitle: '' });
    const [subjectTeachings, setSubjectTeachings] = useState([]);
    const [searchParams, setSearchParams] = useState({
        freeTextSearch: '',
        facultyId: faId || '',
        pageIndex: 1,
        pageSize: 15,
        display: 0
    });
    const [pagination, setPagination] = useState({
        totalItems: 0,
        totalPages: 1,
        currentPage: 1
    });

    const [idDelete, setIdDelete] = useState(null);
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: '',
        subTitle: ''
    });

    useEffect(() => {
        if(faculties.length === 0) {
            getFaculties();
        }
        fetchSubjectTeachings();
    }, [searchParams.display, searchParams.pageIndex, searchParams.facultyId]);

    useEffect(() => {
        localStorage.setItem('faculty', faculty);
        setFaId(faculty);
    }, [faculty]);

    async function getFaculties() {
        try {
            const res: any = await $api.faculties.getPaging({});
            if (res && res.result['items'].length > 0) {
                setFaculties(res.result.items);
                if (faId) {
                    setFaculty(faId);
                } else {
                    setFaculty(res.result.items[0].id);
                    setFaId(res.result.items[0].id);
                }
            }
        } catch (e) {
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function fetchSubjectTeachings() {
        try {
            dispatch(setLoading(true));
            const res: any = await $api.schedule.subjectTeaching_getPaging(searchParams);

            if (res && res.result) {
                setSubjectTeachings(res.result.items);
                setPagination({
                    totalItems: res.result.totalRecord,
                    totalPages: Math.ceil(res.result.totalRecord / searchParams.pageSize),
                    currentPage: searchParams.pageIndex
                });
            }
            dispatch(setLoading(false));
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            if (typeof e?.response?.data?.errors?.exceptionMessage === 'string') {
                errMsg = e.response.data.errors.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e.response.data.errors.exceptionMessage.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    function show_ErrMsg(msg) {
        setErrDialog({
            isOpen: true,
            subTitle: msg
        });
    }

    function handleSearchChange(e) {
        setSearchParams({
            ...searchParams,
            freeTextSearch: e.target.value,
            pageIndex: 1
        });
    }

    function handleDisplayChange(e) {
        setSearchParams({
            ...searchParams,
            display: parseInt(e.target.value),
            pageIndex: 1 // Reset to first page when filter changes
        });
    }

    function handlePageChange(page) {
        setSearchParams({
            ...searchParams,
            pageIndex: page
        });
    }

    async function deleteItem() {
        setConfirmDialog({ isOpen: false, title: '', subTitle: '' });
        try {
            dispatch(setLoading(true));
            const res: any = await $api.schedule.subjectTeaching_delete(
                idDelete
            );
            if (res) {
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
                dispatch(setLoading(false));
            }
            setIdDelete(null);
            fetchSubjectTeachings();
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    async function deleteScheduleSubject(id) {
        setConfirmDialog({
            isOpen: true,
            title: 'Thông báo',
            subTitle: 'Bạn có chắc muốn xóa ?'
        });
        setIdDelete(id);
    }

    return (
        <DefaultLayout>
            <div className='subject-teaching-search page'>
                <div className='page__header'>
                    <div className='___title flex items-center'>
                        <div className='___title__decorate' />
                        <div>Danh sách lịch dạy</div>
                    </div>
                </div>

                <div className='page__content bg-white mt-3'>
                    <div
                        className='filters flex flex-col md:flex-row items-stretch md:items-center justify-between mb-4 gap-4'>
                        {/* Phần chọn khoa */}
                        <div className='w-full md:w-auto'>
                            <div className='pl-1 text-sm font-semibold mb-2 text-gray-600'>
                                Khoa
                            </div>
                            <select
                                className='w-full  block px-3 py-2 border border-gray-300
                      placeholder-gray-500 rounded-md
                      focus:outline-none focus:ring-1
                      focus:ring-blue-700'
                                value={faculty}
                                onChange={(e) => {
                                    setFaculty(e.target.value);
                                    setSearchParams({
                                        ...searchParams,
                                        facultyId: e.target.value,
                                        pageIndex: 1
                                    });
                                }}>
                                {faculties.map((item: any) => (
                                    <option value={item.id} key={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Phần tìm kiếm và filter */}
                        <div className='flex flex-col sm:flex-row gap-4 w-full md:w-auto'>
                            <div className='w-full sm:w-40'>
                                <label className='block text-sm font-semibold mb-1 text-gray-600'>
                                    Trạng thái
                                </label>
                                <select
                                    className='w-full px-3 py-2 border border-gray-300
                          rounded-md focus:outline-none focus:ring-1
                          focus:ring-blue-700'
                                    value={searchParams.display}
                                    onChange={handleDisplayChange}
                                >
                                    <option value={0}>Tất cả</option>
                                    <option value={1}>Đã bắt đầu</option>
                                    <option value={2}>Đã kết thúc</option>
                                    <option value={3}>Chưa bắt đầu</option>
                                </select>
                            </div>

                            {/* Ô tìm kiếm */}
                            <div className='flex-1 min-w-0'>
                                <label className='block text-sm font-semibold mb-1 text-gray-600'>
                                    Tìm kiếm
                                </label>
                                <div className='flex flex-col sm:flex-row gap-2 sm:items-center'>
                                    <input
                                        type='text'
                                        className='flex-1 min-w-0 px-3 py-2 border border-gray-300
                              rounded-md focus:outline-none focus:ring-1
                              focus:ring-blue-700'
                                        placeholder='Tìm theo tên môn học, giáo viên...'
                                        value={searchParams.freeTextSearch}
                                        onChange={handleSearchChange}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                fetchSubjectTeachings();
                                            }
                                        }}
                                    />

                                    <button
                                        className='bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded'
                                        onClick={fetchSubjectTeachings}
                                    >
                                        Tìm kiếm
                                    </button>

                                </div>
                            </div>


                        </div>
                    </div>

                    <div className='overflow-x-auto'>
                        <table className='min-w-full bg-white'>
                            <thead className='bg-gray-100'>
                            <tr>
                                <th className='py-2 px-4 border'>STT</th>
                                <th className='py-2 px-4 border'>Tên môn học</th>
                                <th className='py-2 px-4 border'>Tên lịch dạy</th>
                                <th className='py-2 px-4 border'>Giáo viên</th>
                                <th className='py-2 px-4 border'>Ngày bắt đầu</th>
                                <th className='py-2 px-4 border'>Sinh viên</th>
                                <th className='py-2 px-4 border'>Số buổi dạy</th>
                                <th className='py-2 px-4 border'>Số buổi điểm danh</th>
                                <th className='py-2 px-4 border'>Hành động</th>
                            </tr>
                            </thead>
                            <tbody>
                            {subjectTeachings.length > 0 ? (
                                subjectTeachings.map((item: any, index) => (
                                    <tr key={item.id} className='hover:bg-gray-50 cursor-pointer'>
                                        <td className='border text-center'>
                                            <Link to={`/lich-hoc-mon-chitiet/${item.id}`} className="py-2 px-4 block w-full h-full hover:no-underline hover:text-black">
                                                {(searchParams.pageIndex - 1) * searchParams.pageSize + index + 1}
                                            </Link>
                                        </td>
                                        <td className='border'>
                                            <Link
                                                to={`/lich-hoc-mon-chitiet/${item.id}`} className="py-2 px-4 block w-full h-full hover:no-underline hover:text-black">
                                                {item.subject?.name || 'N/A'}
                                            </Link>
                                        </td>
                                        <td className='border'>
                                            <Link to={`/lich-hoc-mon-chitiet/${item.id}`} className="py-2 px-4 block w-full h-full hover:no-underline hover:text-black">
                                                {item.name || 'N/A'}
                                            </Link>
                                        </td>
                                        <td className='border'>
                                            <Link
                                                to={`/lich-hoc-mon-chitiet/${item.id}`} className="py-2 px-4 block w-full h-full hover:no-underline hover:text-black">
                                                {item.teacher?.fullName || 'N/A'}
                                            </Link>
                                        </td>
                                        <td className='border text-center'>
                                            <Link to={`/lich-hoc-mon-chitiet/${item.id}`} className="py-2 px-4 block w-full h-full hover:no-underline hover:text-black">
                                                {item.startDate &&
                                                moment(item.startDate).isValid() ? (
                                                    // @ts-ignore
                                                    <Moment format='DD/MM/YYYY'>
                                                        {item.startDate}
                                                    </Moment>
                                                ) : (
                                                    <div>{item.startDate}</div>
                                                )}
                                            </Link>
                                        </td>
                                        <td className='border text-center'>
                                            <Link
                                                to={`/lich-hoc-mon-chitiet/${item.id}`} className="py-2 px-4 block w-full h-full hover:no-underline hover:text-black">
                                                {item.numberOfStudent}
                                            </Link>
                                        </td>
                                        <td className='border text-center'>
                                            <Link
                                                to={`/lich-hoc-mon-chitiet/${item.id}`} className="py-2 px-4 block w-full h-full hover:no-underline hover:text-black">
                                                {item.numberOfSubjectSchedule}
                                            </Link>
                                        </td>
                                        <td className='border text-center'>
                                            <Link
                                                to={`/lich-hoc-mon-chitiet/${item.id}`} className="py-2 px-4 block w-full h-full hover:no-underline hover:text-black">
                                                {item.numberOfTaughtSubjectSchedule}
                                            </Link>
                                        </td>
                                        <td className="border">
                                            <div className="flex items-center justify-center gap-3 h-full py-2">
                                                <Link
                                                    to={`/chi-tiet-lop-mon-hoc/${item.id}`}
                                                    className="text-blue-600 hover:text-blue-800"
                                                >
                                                    <i className="far fa-eye" />
                                                </Link>
                                                <button
                                                    className="text-red-600 hover:text-red-800"
                                                    onClick={() => deleteScheduleSubject(item.id)}
                                                >
                                                    Xóa
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={9} className='py-4 px-4 border text-center text-gray-500'>
                                        Không có dữ liệu
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>


                    <div className='pagination'>
                        <Pagination
                            page={pagination.currentPage}
                            total={pagination.totalItems}
                            pages={pagination.totalPages}
                            clickedPage={handlePageChange}
                        />
                    </div>
                </div>
                <ConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                    deleteItem={deleteItem}
                />

                <ErrorDialog
                    errorDialog={errDialog}
                    setErrorDialog={setErrDialog}
                />
            </div>
        </DefaultLayout>
    );
}

export default SubjectTeachingSearch;